import { amplitude } from '@sennder/senn-node-analytics-frontend'
import { AmplitudeLogLevel } from '@sennder/senn-node-analytics-frontend/lib/types'
import { AMPLITUDE_API_KEY, isUatEnv } from '@/common/config'
import { getStateUser } from '@/store'
import { executeSafelyWithLogging } from './errors-handler'
import { amplitudeLogger } from './amplitudeLogger'
import { logger } from './logger/loggers'

export function initAnalytics() {
  return executeSafelyWithLogging(() => {
    if (isUatEnv()) {
      logger.warn(
        '[ts-website-serverless - Analytics]: Amplitude is not available in UAT environment',
        {},
      )
      return
    }
    if (!AMPLITUDE_API_KEY) {
      throw new Error('[ts-website-serverless - Analytics]: AMPLITUDE_API_KEY not found')
    }
    amplitude.init({
      token: AMPLITUDE_API_KEY,
      appName: 'ts-website-serverless',
      amplitudeConfig: {
        loggerProvider: amplitudeLogger,
        logLevel: AmplitudeLogLevel.Warn,
      },
    })
  }, 'amplitude.init')
}

export function identifyUserInAnalytics(onLogin: boolean) {
  const user = getStateUser()

  const analyticsUser = {
    // TODO: Define custom user properties
    userId: user.id.toString(),
    userName: user.username,
    language: user.language,
  }

  executeSafelyWithLogging(
    () =>
      // TODO: Define custom group properties
      amplitude.identifyUser(analyticsUser, onLogin, {
        groupType: 'ts-website-serverless id',
        groupValue: 'ts-website-serverless group value',
      }),
    'amplitude.identifyUser',
  )
}

export const resetAnalyticsSession = () => {
  executeSafelyWithLogging(() => amplitude.endSession(), 'amplitude.endSession')
  initAnalytics()
}

// Used when the user rejects analytics cookies,
// all user data will be removed from the analytics integration as well as any event submissions will be terminated
export const stopAnalytics = () => {
  executeSafelyWithLogging(
    () => amplitude.stopTracking(),
    'amplitude.stopTracking',
  )
}
